import * as game from './game';
export default function BaseColumns(
  keys: (feeds.keys | game.keys | string | any)[],
  params: any,
) {
  const columns: any = {
    ...game.columns(params),
  };

  return keys
    .filter((item) => {
      if (typeof item === 'string') return !!columns[item];
      if (typeof item !== 'object') return false;
      return !!columns[item.key];
    })
    .map((item) => {
      if (typeof item === 'string') return columns[item];
      const { key } = item;

      return {
        ...columns[key],
        ...item,
      };
    });
}
